module.exports = __webpack_public_path__ + "img/za.94f5133a.svg";